<template>
    <div class="compare-item-container">
        <div class="d-flex flex-column align-items-center">
            <img class="compare-logo"
                 :src="logoUrl"
                 :alt="name"
                 :title="name">
            <div class="compare-title">
                {{ name }}
            </div>
        </div>
        <div class="compare-score">
            {{ reviewInternalScore }}
            <MenuStars :score="parseFloat(reviewInternalScore)"
                       :starsCount="STARS_COUNT" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import MenuStars from '../components/MenuStars.vue';
    import { INavigationCompareItem } from '../types/menuTypes';

    defineProps<INavigationCompareItem>();

    const STARS_COUNT = 5;
</script>

<style scoped lang="scss">
.compare-item-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 10px 6px;

    .compare-logo {
        width: 100%;
    }

    .compare-title {
        width: 90px;
        min-height: 32px;
        margin-top: 4px;
        margin-bottom: 12px;
        font-size: 12px;
        font-weight: 700;
        line-height: 16px;
        text-align: center;
    }

    .compare-score {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 24px;
        font-weight: 700;
        line-height: 20px;
    }
}

.dark-theme {
    .compare-logo {
        filter: grayscale(1) invert(1) brightness(300%);
    }
}
</style>
